import React from "react";
import { TextField, Box, Stack} from "@mui/material";

export default function VirmentForm(props) {

    return(
        <Box display="flex" flexDirection="column" rowGap={2}>
            <TextField fullWidth required={typeof props.isdepense ==='boolean' ? false : true}
            label={props.pay_mode==='cb' ? "N° ticket marchand" :  "Référence"}
            // maxleng?
            value={props.repartition.ref}
            onChange={(e)=> props.setRepartition(old => ({...old, ref: e.target.value}))}/>

            <Stack direction={'row'} spacing={1}>
                <TextField type="date" label={"Date"} fullWidth
                required={typeof props.isdepense ==='boolean' ? false : true}
                slotProps={{inputLabel: {shrink: true}, htmlInput:{ max: new Date(props.don_date).toISOString().split("T")[0]}}}
                value={props.repartition.date}
                onChange={(e)=>props.setRepartition(old => {old.date = e.target.value; return {...old}})}/>

                <TextField fullWidth required label="montant" type="number"
                slotProps={{inputLabel: {shrink: true}, htmlInput:{step:"0.01", min:'0'}}}
                value={props.repartition.montant}
                onFocus={()=>{if(props.repartition.montant===0) props.setRepartition(old => ({...old, montant: ''}))}}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setReptotal(old => old-props.repartition.montant+Number(e.target.value))
                    props.setRepartition(previous => ({...previous, montant: Number(e.target.value)}))
                }else if(e.target.value===''){
                    props.setReptotal(old => old-props.repartition.montant)
                    props.setRepartition(previous => ({...previous, montant: ''}))
                }}}/>
            </Stack>
        </Box>
    )
}